<template>
  <v-dialog :persistent="persistent" v-model="dialog" max-width="800px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("$vuetify.alert") }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon
              v-bind="attrs"
              v-on="on"
              @click="
                dialog = false;
                $emit('cancel');
              "
            >
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-data-table
        :headers="headers"
        :items="errorData"
        multi-sort
        class="elevation-0 px-6"
        :footer-props="
          Object.assign({}, $t('$config.footer-props'), {
            itemsPerPageOptions: [5],
          })
        "
      >
        <template v-slot:item.public_flg="{ item }">
          <v-chip
            small
            label
            :color="item.public_flg ? 'primary' : 'grey'"
            text-color="white"
          >
            {{
              item.public_flg
                  ? $t("Material.publicFlgs.on")
                  : $t("Material.publicFlgs.off")
            }}
          </v-chip>
        </template>
      </v-data-table>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary"
          outlined
          @click="
            $emit('cancel');
            dialog = false;
          "
        >
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn
          v-if="useConfirm"
          color="accent"
          depressed
          @click="
            $emit('confirm');
            dialog = false;
          "
        >
          {{ $t("$vuetify.confirm") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import i18n from "@/i18n";

export default {
  name: "DialogAlert",

  props: {
    value: Boolean,
    title: String,
    useConfirm: Boolean,
    persistent: Boolean,
    errorData: Array,
  },

  data: () => ({
    dialog: false,
  }),

  watch: {
    value: {
      immediate: true,
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        this.$emit("input", this.dialog);
        if (!this.dialog) this.$emit("close");
      },
    },
  },
  computed: {
    headers() {
      return [
        {
          text: i18n.t("Material.Fields.material_category"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "category_name",
        },
        {
          text: i18n.t("Material.Fields.material_code"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "material_code",
        },
        {
          text: i18n.t("Material.Fields.material_name"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "material_name",
        },
        {
          text: i18n.t("Material.Fields.public_flg"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "public_flg",
        },
      ];
    },
  },
};
</script>
